// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__L1J24","col":"styles_col__1hNl-","fulfillmentStatus":"styles_fulfillmentStatus__3zU-N","emailCol":"styles_emailCol__2J6PX"};